import { render, staticRenderFns } from "./ClientPerformance.vue?vue&type=template&id=d396459a&scoped=true&"
import script from "./ClientPerformance.vue?vue&type=script&lang=js&"
export * from "./ClientPerformance.vue?vue&type=script&lang=js&"
import style0 from "./ClientPerformance.vue?vue&type=style&index=0&id=d396459a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d396459a",
  null
  
)

export default component.exports